import ControllerBase from 'global/js/ControllerBase';
import { FilterDataProps } from 'wolf/components/organisms/o-job-offers/o-job-offers.controller';
import { MoleculeJobOfferSearchEvents } from './m-job-offer-search.events';

interface ComponentRefs {
	textInput: 'textInput';
	searchButton: 'searchButton';
	clearButton: 'clearButton';
	selectWrapper: 'selectWrapper';
}

export default class ControllerJobOfferSearch extends ControllerBase<ComponentRefs> {
	private text: HTMLInputElement;
	private clearBtn: HTMLAnchorElement;
	private searchBtn: HTMLSpanElement;
	private selects: HTMLSelectElement[];

	constructor(element: HTMLElement) {
		super(element);
		this.text = this.$references.textInput as HTMLInputElement;
		this.clearBtn = this.$references.clearButton as HTMLAnchorElement;
		this.searchBtn = this.$references.searchButton as HTMLAnchorElement;
		this.selects = Array.from(this.$references.selectWrapper.querySelectorAll('.js-select')) as HTMLSelectElement[];

		this.init();
	}

	private init() {
		this.createEvents();
	}

	private createEvents(): void {
		this.searchBtn &&
			this.searchBtn.addEventListener('click', (e: MouseEvent | PointerEvent) => {
				e.preventDefault();
				this.emitTextEvent();
			});

		this.text &&
			this.text.addEventListener('keyup', (e: KeyboardEvent) => {
				if (e.code === 'Enter') {
					this.emitTextEvent();
				}
			});

		this.selects.forEach((select) => {
			select.addEventListener('change', (e) => this.handleChangeEvent());
		});

		this.clearBtn &&
			this.clearBtn.addEventListener('click', (e: MouseEvent | PointerEvent) => {
				e.preventDefault();
				this.clearAll();
			});
	}

	private handleChangeEvent(): void {
		let filterData: FilterDataProps;

		if (this.text.value !== '') {
			filterData = {
				selects: this.loadValues(),
				search: this.text.value,
			};
		} else {
			filterData = {selects: this.loadValues()};
		}

		this.dispatchCustomEvent<FilterDataProps>(MoleculeJobOfferSearchEvents.inputChange, filterData, true, true);
	}

	private loadValues(): any {
		const filters: FilterDataProps['selects'] = [];

		this.selects.forEach((s) => {
			filters.push({ key: s.name, value: s.value });
		});

		return filters;
	}

	private clearAll() {
		this.text.value = '';
		this.selects.forEach((select) => {
			select.value = select.options[0].value;
		});

		this.dispatchCustomEvent(MoleculeJobOfferSearchEvents.clearButton, {}, true, true);
	}

	private emitTextEvent(): void {
		const filterData: FilterDataProps = {
			...this.loadValues(),
			search: this.text.value,
		};
		this.dispatchCustomEvent<FilterDataProps>(MoleculeJobOfferSearchEvents.searchButton, filterData, true, true);
	}
}
